import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import type { GenericProductData } from '@legacy/common-ui-models';
import { MediaObserverService } from '@innogy/shared/responsive-tools';
import { NgTemplateOutlet, AsyncPipe } from '@angular/common';

import { GenericOfferCarouselComponent } from '../generic-offer-carousel/generic-offer-carousel.component';

@Component({
  selector: 'wl-generic-offer-container[products][listName]',
  templateUrl: './generic-offer-container.component.html',
  styleUrls: [
    './generic-offer-container.component.essent.scss',
    './generic-offer-container.component.ed.scss',
  ],
  standalone: true,
  imports: [GenericOfferCarouselComponent, NgTemplateOutlet, AsyncPipe],
})
export class GenericOfferContainerComponent<
  TProduct extends GenericProductData,
> {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() products!: TProduct[];

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() listName!: string;

  @Output()
  productClicked = new EventEmitter<TProduct[]>();

  @ContentChild(TemplateRef)
  productTemplate?: TemplateRef<TProduct>;

  deviceInfo$ = this.mediaObserver.deviceInfo$;

  constructor(private readonly mediaObserver: MediaObserverService) {}

  hasReserveHighlightSpace() {
    return this.products.some((e) => e.content.highlight);
  }
}
